import { Card } from 'antd';
import PropTypes from 'prop-types';
import styles from './spot-lead-welcome.module.scss';

/**
 * SpotLeadsWelcome
 *
 * Main component that acts as a container for welcome content.
 *
 * @param {Object} props - Component properties
 * @param {React.ReactNode} props.children - Content to display inside the card
 */
export const SpotLeadsWelcome = ({ children, ...props }) => (
  <Card className={`spot-welcome-card ${styles.card}`} {...props}>
    {children}
  </Card>
);

SpotLeadsWelcome.propTypes = {
  children: PropTypes.node,
};

/**
 * SpotLeadsWelcome.Header
 *
 * Header section for the SpotLeadsWelcome component.
 *
 * @param {Object} props - Component properties
 * @param {string} props.title - Header title
 * @param {string} props.description - Header description
 * @param {React.ReactNode} props.icon - Icon to display in the header
 */
SpotLeadsWelcome.Header = ({ title, description, icon, ...props }) => (
  <div className={styles.header} {...props}>
    <div className={styles.icon}>{icon || icon}</div>
    <div className={styles.text}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{description}</p>
    </div>
  </div>
);

SpotLeadsWelcome.Header.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.node,
};

/**
 * SpotLeadsWelcome.Footer
 *
 * Footer section for the SpotLeadsWelcome component.
 *
 * @param {Object} props - Component properties
 * @param {React.ReactNode} props.children - Content to display in the footer
 */
SpotLeadsWelcome.Footer = (props) => (
  <div className={styles.footer} {...props}>
    {props.children}
  </div>
);

SpotLeadsWelcome.Footer.propTypes = {
  children: PropTypes.node,
};
